import { SelectParcelProvider } from './SelectParcelPageContext';
import SelectParcelScreenContainer from '../../containers/SelectParcelScreenContainer';

export default function SelectParcelPage() {
  return (
    <SelectParcelProvider>
      <SelectParcelScreenContainer />
    </SelectParcelProvider>
  );
}
